export const services = [
  {
    icon: "bi:ui-radios",
    title: "Front-end Development",
    desc: `I specialize in creating visually stunning and user-friendly web
    interfaces that engage and captivate users. With expertise in
    HTML, CSS, and JavaScript, I craft responsive and accessible
    websites that seamlessly adapt to various devices and screen
    sizes.`,
  },
  {
    icon: "material-symbols:database-outline",
    title: "Backend Development",
    desc: `My services encompass the entire backend development lifecycle,
    from designing the data architecture to implementing powerful
    APIs and integrating with databases. I specialize in crafting
    RESTful APIs that enable seamless communication between the
    frontend and backend, allowing for dynamic content delivery and
    real-time interactions.`,
  },
  // {
  //   icon: "fluent:design-ideas-16-regular",
  //   title: "UI/UX Design",
  //   desc: `I design captivating user experiences that seamlessly blend form
  //   and function. From wireframing to prototyping, I ensure
  //   intuitive interactions that leave a lasting impression. Let's
  //   collaborate to create beautiful designs that drive user
  //   satisfaction and elevate your digital presence.`,
  // },
  {
    icon: "grommet-icons:docker",
    title: "DevOps",
    desc: `Elevate your project efficiency with my DevOps expertise. I seamlessly integrate development and operations, streamlining workflows for faster, error-free deliveries. From continuous integration to automated testing and deployment, I ensure your software development lifecycle is optimized for peak performance.`,
  },
  {
    icon: "carbon:cloud-services",
    title: "Cloud Administration",
    desc: `Elevate your digital presence with my Cloud Administration expertise. Specializing in AWS and Azure, I architect and manage cloud infrastructures, prioritizing robust security and optimizing performance. From deployment to ongoing management, I ensure your applications thrive in the cloud, guaranteeing reliability and innovation for your digital journey.`,
  },
  // {
  //   icon: "ri:seo-line",
  //   title: "SEO Optimization",
  //   desc: `As an SEO Optimizer, I work magic on search engines, waving my
  //   keyword wand to make your website rise through the ranks. I'll
  //   sprinkle some meta tags, sprinkle some backlinks, and voila!
  //   Your website will be on top...well, hopefully. Let's dance with
  //   algorithms and embrace the ever-changing SEO game.`,
  // },
];
